import { useSyncExternalStore } from 'react';

export const CONTENT_LANGUAGE_HEADER = 'x-shmh-language';
export const CONTENT_LANGUAGE_STORAGE_KEY = 'shmh-admin-content-language';

export type ContentLanguage = 'en' | 'es';

const changeEvent = 'shmh:content-language-change';

function readStoredLanguage(): ContentLanguage {
  if (typeof window === 'undefined') return 'en';
  try {
    return window.localStorage.getItem(CONTENT_LANGUAGE_STORAGE_KEY) === 'es' ? 'es' : 'en';
  } catch {
    return 'en';
  }
}

let currentLanguage = readStoredLanguage();

export function getContentLanguage(): ContentLanguage {
  return currentLanguage;
}

export function setContentLanguage(language: ContentLanguage): void {
  currentLanguage = language;
  try {
    window.localStorage.setItem(CONTENT_LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Storage may be unavailable in restrictive browsing modes.
  }
  window.dispatchEvent(new Event(changeEvent));
}

function subscribe(callback: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== CONTENT_LANGUAGE_STORAGE_KEY) return;
    currentLanguage = event.newValue === 'es' ? 'es' : 'en';
    callback();
  };
  window.addEventListener(changeEvent, callback);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(changeEvent, callback);
    window.removeEventListener('storage', onStorage);
  };
}

export function useContentLanguage(): ContentLanguage {
  return useSyncExternalStore(subscribe, getContentLanguage, () => 'en');
}
